import React from "react";
import RulesIconFill from "../assets/icons/rules-icon-fill.svg";
import FaqIconFill from "../assets/icons/faq-icon-fill.svg";
import {useNavigate} from "react-router-dom";

function RulesFaq() {
    const navigate = useNavigate()

    return (
        <div className="rules-faq">
            <video controls height={225}>
                <source
                    src="https://cryptolottery777.com/public/video/1"
                    type="video/mp4"
                />
                Ваш браузер не поддерживает HTML-видео.
            </video>
            <div className="friends_friends-group">
                <div className="friends_friends-group__title" style={{marginBottom: '12px'}}>
                    Правила
                </div>
                <div className="friends_friends-group__item" onClick={() => navigate('/rules')}>
                    <div className="friends_friends-group__item___info">
                        <img src={RulesIconFill} alt="" width={32} height={32}/>
                        <span>Правила</span>
                    </div>
                </div>
                <div className="friends_friends-group__item" onClick={() => navigate('/faq')}>
                    <div className="friends_friends-group__item___info">
                        <img src={FaqIconFill} alt="" width={32} height={32}/>
                        <span>ЧАВО</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RulesFaq